import React from "react";
import _ from "lodash";
import * as Code from "@repoflow/components/code";

export const View = (props) => {
  const { value } = props;
  return <span>{value}</span>;
};

export const Edit = (props) => {
  const {
    value,
    setValue,
    field: { height: heightCnf, fill },
    labelId,
    describedById,
  } = props;

  return (
    <Code.Control
      // What names the editor's `.cm-content` — the form's label and
      // description. This widget renders the control straight from Edit rather
      // than through FormInput, and the object widget hands the ids to Edit
      // just the same. Both undefined in a table cell, and the editor leaves
      // an undefined one out.
      labelId={labelId}
      describedById={describedById}
      mode={"text/x-sql"}
      value={value}
      onChange={setValue}
      layout={{
        width: "100%",
      }}
    />
  );
};

export const config = { isWide: true };
